import { createBaseStore } from '@/stores/api/base.js';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useLedPanelStore = defineStore('ledPanel', () => {
  const {
    items: ledpanels,
    fetchItems: fetch,
    storeItem: store,
    updateItem: update,
    destroy,
  } = createBaseStore('api/library/led-panel');

  const personal = ref([]);
  const global = ref([]);
  const fetchGlobal = async () => {
    const overrideUrl = `/api/library/led-panel/?disguise_only=true`;
    const response = await fetch(null, overrideUrl);
    global.value = response && response.length > 0 ? response : [];
    return response;
  };

  const fetchSelf = async () => {
    const overrideUrl = `/api/library/led-panel/?self_only=true`;
    const response = await fetch(null, overrideUrl);
    personal.value = response && response.length > 0 ? response : [];
    return response;
  };

  const getLedPanelDataByCode = (code) => {
    const allLedPanels = [...(personal.value || []), ...(global.value || [])];
    return allLedPanels.find((ledPanel) => ledPanel.code === code);
  };

  return {
    ledpanels,
    fetch,
    destroy,
    update,
    store,
    personal,
    global,

    fetchGlobal,
    fetchSelf,
    getLedPanelDataByCode,
  };
});
